'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M64 400c0 44.2 35.8 80 80 80l224 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-224 0c-44.2 0-80 35.8-80 80zM96 224l0 74.8c14.5-6.9 30.8-10.8 48-10.8l224 0c17.2 0 33.5 3.9 48 10.8l0-42.8c0-17.7-14.3-32-32-32L96 224zm72 176a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm112 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm112 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M257.7 67.4l62.3 124.6 32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c35.3 0 64 28.7 64 64l0 48 96 0 0-96c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48 8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80-35.8-80-80l0-96-84.1 0c12.7 18.1 20.1 40.2 20.1 64 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4L64 96c0-35.3 28.7-64 64-64l72.4 0c24.2 0 46.4 13.7 57.2 35.4zM96 298.8c14.5-6.9 30.8-10.8 48-10.8l224 0c17.2 0 33.5 3.9 48 10.8l0-42.8c0-17.7-14.3-32-32-32l-288 0 0 74.8zM229.1 81.7C223.6 70.8 212.6 64 200.4 64L128 64c-17.7 0-32 14.3-32 32l0 96 188.2 0-55.2-110.3zM144 320c-44.2 0-80 35.8-80 80s35.8 80 80 80l224 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-224 0zm200 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-88-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;